module.exports = require('./helpers/bundle-url').getBundleURL('gIXIs') + "logo-dark.ba5147f0.svg";